import { gql } from '@apollo/client';

export const otpSmsSend = gql`
  mutation otpSmsSend($otpSmsSendParams: OtpSmsSendParams!) {
    otpSmsSend(otpSmsSendParams: $otpSmsSendParams) {
      success
      alterError {
        data
        errorCode
        message
      }
    }
  }
`;

export const otpSmsConfirm = gql`
  mutation otpSmsConfirm($otpSmsConfirmParams: OtpSmsConfirmParams!) {
    otpSmsConfirm(otpSmsConfirmParams: $otpSmsConfirmParams) {
      tokenSet {
        access_token
        expires_in
        id_token
      }
      alterError {
        data
        errorCode
        message
      }
    }
  }
`;
